import React from 'react';
import { dayNum, monthShort } from '../../../shared/utils/dates';

const Badge = ({ status }) =>
    status === 'approved' ? (
        <span className="reg-badge reg-approved">Approved</span>
    ) : (
        <span className="reg-badge reg-pending">Pending</span>
    );

// Events the user has requested to attend. Only rendered when there's at least
// one registration — no empty/guest state.
const MySessions = ({ sessions = [] }) => {
    if (!sessions.length) return null;

    return (
        <div className="sidebar-card">
            <h3>My Registered Events</h3>
            <p className="sidebar-card__hint">Events you have requested to attend.</p>
            <div>
                {sessions.map((s, i) => {
                    const Row = s.url ? 'a' : 'div';
                    return (
                        <Row key={i} className="saved-item-reg" href={s.url || undefined}>
                            <div className="date-box">
                                <strong>{dayNum(s.date)}</strong>
                                <span>{monthShort(s.date)}</span>
                            </div>
                            <div>
                                <h4>{s.title}</h4>
                                {s.chapter && <p>{s.chapter}</p>}
                            </div>
                            <Badge status={s.status} />
                        </Row>
                    );
                })}
            </div>
        </div>
    );
};

export default MySessions;
